import { FC } from 'react'
import { InputTextType } from '../../../common/InputType'
import { SelectType } from '../level_1/SelectBox'

type Props = {
  first: SelectType
  second: InputTextType
}

const SelectInputText: FC<Props> = (props) => {
  const { first, second } = props

  return (
    <div className="switcher">
      <span>
        <select
          id={first.id}
          autoComplete={first.autoComplete}
          value={first.state}
          onChange={(e) => first.setState(e.target.value)}
          style={{ width: '100%' }}
        >
          {first.options}
        </select>
      </span>
      <span>
        <input
          type={second.type}
          id={second.id}
          autoComplete={second.autoComplete}
          placeholder={second.placeholder}
          style={{ width: '100%' }}
          value={second.state}
          maxLength={second.maxLength}
          onChange={(e) => second.setState(e.target.value)}
        />
      </span>
      <span></span>
    </div>
  )
}

export default SelectInputText
